module.exports = __webpack_public_path__ + "img/icon-pod.434c7fc7.svg";